import * as Yup from 'yup';

const cancellationRuleSchema = Yup.object({

    start: Yup.number('Start hrs must be a number')
        .positive('Start hrs must be a positive value')
        .required('Start hrs is required')
        .min(0, 'Your start hrs must be greater than or equal to 0!')
        .max(24, 'Your start hrs must be greater than or equal to 0!'),

    end: Yup.number('End hrs must be a number')
        .positive('End hrs must be a positive value')
        .required('End hrs is required')
        .min(0, 'Your end hrs must be greater than or equal to 0!')
        .max(24, 'Your end hrs must be greater than or equal to 0!'),

    percentage: Yup.number('Percentage must be a number')
        .positive('Percentage must be a positive value')
        .required('Percentage is required')
        .min(0, 'Your percentage must be greater than or equal to 0!')
        .max(100, 'Your percentage must be greater than or equal to 0!')
});

export default cancellationRuleSchema;